// extracted by mini-css-extract-plugin
module.exports = {"container":"Data_container__2Xqt9","sideContainer":"Data_sideContainer__2wgUR","dataContainer":"Data_dataContainer__7i8Xh"};